<template>
  <header
    v-cloak
    :class="[
      $options.$styles.header,
      {
        [`${$options.$styles.toolbarTop}`]: ui.toolbarIsTop,
        [`${$options.$styles.toolbarBottom}`]: !ui.toolbarIsTop,
      },
    ]"
  >
    <div :class="$options.$styles.headerInner">
      <h1 class="px-4 text-sm font-bold text-accent-60">
        <the-logo class="font-light no-underline">
          <span>Battle<span class="font-bold">FX</span> </span>
        </the-logo>
      </h1>
      <div data-test="menus" class="ml-auto flex items-center">
        <ul
          data-test="mainMenu"
          class="flex max-md:border-l max-md:border-accent-20"
        >
          <base-menu-item
            data-test="battleMenuItem"
            exact
            icon="battle"
            to="/battles"
            >Battles</base-menu-item
          >
          <base-menu-item
            data-test="bestiaryMenuItem"
            icon="skull"
            to="/bestiary"
            v-if="loggedIn"
            >Bestiary</base-menu-item
          >
          <base-menu-item
            data-test="faveMenuItem"
            icon="star"
            to="/favourites"
            v-if="loggedIn"
            >Favourites</base-menu-item
          >
          <base-menu-item
            data-test="accountMenuItem"
            icon="user"
            to="/account"
            v-if="loggedIn"
            >{{ username }}</base-menu-item
          >
          <base-menu-item
            data-test="loginMenuItem"
            icon="user"
            to="/login"
            v-else
            >Login</base-menu-item
          >
        </ul>

        <settings />
      </div>
    </div>
  </header>
</template>

<script>
import TheLogo from '@/components/TheLogo'
import Settings from '@/components/Settings'
import BaseMenuItem from '@/components/BaseMenuItem'
import { mapGetters } from 'vuex'

const $styles = {
  header: ` border-bg-lightest fixed l b r z-3 max-sm:border-t`,
  headerInner: ` bg-tint-less flex items-center justify-between `,
  toolbarTop: ` sm:border-b sm:t sm:b-auto `,
  toolbarBottom: ` border-t `,
}

export default {
  components: {
    TheLogo,
    Settings,
    BaseMenuItem,
  },
  inject: [`ui`],
  computed: {
    ...mapGetters(`accounts`, [`loggedIn`, `username`]),
  },
  $styles,
}
</script>
